import LeaderboardList from "../components/LeaderboardList";
import LeaderboardTabs from "../components/LeaderboardTabs";

function Leaderboard() {
  return (
    <div>
      <LeaderboardTabs />
      <LeaderboardList />
    </div>
  );
}

export default Leaderboard;
